// extracted by mini-css-extract-plugin
export default {"callToActionButtonWrapper":"CallToActionButton_callToActionButtonWrapper__bOF0i","callToActionButton":"CallToActionButton_callToActionButton__GNkk4"};